
export default class Base64 {
    static getBase64(data, callback) {
        if (data instanceof File) {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            }
            reader.readAsDataURL(data);
        } else {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', data);
            xhr.responseType = 'blob';
            xhr.send();
        }
    }
}